import React from 'react';
import { motion } from 'framer-motion';
import { FlameIcon } from 'lucide-react';
export function About() {
  return <section className="py-16 px-6" data-id="element-5">
      <div className="max-w-3xl mx-auto" data-id="element-6">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-8" data-id="element-7">
          <h2 className="text-2xl md:text-3xl font-bold text-cream mb-2 flex items-center justify-center gap-2" data-id="element-8">
            <FlameIcon className="w-6 h-6 text-flame" data-id="element-9" />
            About the Vibe
          </h2>
        </motion.div>

        <motion.blockquote initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="relative p-8 rounded-2xl bg-forest-card/50 backdrop-blur-sm border border-forest-light/20" data-id="element-10">
          <div className="absolute -top-3 left-8 text-5xl text-forest-light/40" data-id="element-11">
            "
          </div>
          <p className="text-cream text-lg leading-relaxed mb-4 relative z-10" data-id="element-12">
            Like Sugaar, the shapeshifting serpent of Basque mythology, vibe
            coding is about transformation — turning raw ideas into living
            products through the fire of AI-assisted creation.
          </p>
          <p className="text-parchment text-base" data-id="element-13">
            I believe the best products come from rapid iteration and genuine
            curiosity. Every app here started as a "what if" and became
            something real.
          </p>
        </motion.blockquote>
      </div>
    </section>;
}